<template>
    <div class="gmf-review-summary-container" v-if="summary">
        <div class="gmf-review-summary-body">
            <div class="gmf-review-summary-content">
                <div class="gmf-subheader">{{ t('ai_review_summary.title') }}</div>
                <div class="gmf-review-summary-text" v-text="summary.text" />
                <div class="gmf-review-summary-footer" v-if="productScore || showBanner">
                    <RatingStars v-if="productScore" :rating="productScore" type="product_score" />
                    <img v-if="showBanner" :src="bannerImage" class="gmf-banner-bottom" />
                </div>
            </div>
            <img v-if="showBanner" :src="bannerImage" class="gmf-banner-side" />
        </div>
        <div class="gmf-review-summary-poweredby gmf-text-small">{{ t('ai_review_summary.poweredby') }}</div>
    </div>
</template>

<style>
.gmf-review-summary-container {
    container-type: inline-size;
}

.gmf-review-summary-body {
    background: var(--gmf-card-col);
    display: flex;
    padding: var(--gmf-p-4);
    border-radius: var(--gmf-rounding);
    gap: var(--gmf-p-3);
}
.gmf-review-summary-content {
    display: flex;
    flex-direction: column;
    gap: var(--gmf-p-3);
}

.gmf-review-summary-body .gmf-subheader {
    margin: 0 !important;
}

.gmf-review-summary-poweredby {
    text-align: center;
    margin-top: var(--gmf-p-3);
}

.gmf-review-summary-footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: var(--gmf-p-2);
}

/* Side banner - shown by default */
.gmf-banner-side {
    max-height: 128px;
    width: auto;
    object-fit: cover;
    border-radius: var(--gmf-rounding);
    margin-bottom: calc(0px - var(--gmf-p-4));
    align-self: flex-end;
}

/* Bottom banner - hidden by default */
.gmf-banner-bottom {
    margin-left: auto;
    max-height: 96px;
    margin-top: calc(0px - var(--gmf-p-2));
    margin-right: calc(0px - var(--gmf-p-5));
    margin-bottom: calc(0px - var(--gmf-p-4));
    display: none;
}

/* Container query: switch to bottom banner when width < 950px */
@container (max-width: 900px) {
    .gmf-banner-side {
        display: none;
    }
    
    .gmf-banner-bottom {
        display: block;
    }
}
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';
import RatingStars from '@/components/RatingStars';
import getProductRatings from '@/utils/getProductRatings';

export default {
    name: 'ReviewSummary',
    components: {
        RatingStars,
    },
    props: {
        productId: {
            type: String,
            required: true,
        },
        hideStars: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            summary: null,
            rating: null,
        };
    },
    computed: {
        showBanner() {
            return !!this.bannerImage;
        },
        productScore() {
            if (this.rating) {
                return this.rating.ratings?.product_score?.ratingAverage;
            }
            return null;
        },
        bannerImage() {
            return state.merchantConfig.comments?.product_review?.aiSummaries?.bannerImage || null;
        },
    },
    mounted() {
        if (state.merchantConfig.comments?.product_review?.aiSummaries?.enabled) {
            this.loadSummary();
        }
    },
    methods: {
        t: state.t,
        async loadSummary() {
            let ratingPromise = null;
            if (!this.hideStars) {
                ratingPromise = getProductRatings(this.productId);
            }

            const response = await callApi('GET', `/v3/comments/review-summaries/${this.productId}`);
            const json = await response.json();
            this.summary = json.summary;
            if (ratingPromise) {
                this.rating = await ratingPromise;
            }
        },
    },
};
</script>